import {FC, ReactNode} from 'react'

/**
 * Иконки сайдбара в новом дизайне — контурные (Lucide, ISC), вместо duotone-
 * шрифта Metronic. Вшиты как SVG, чтобы не тянуть зависимость ради двух
 * десятков иконок; цвет берётся из .menu-icon через currentColor.
 */
const ICONS: Record<string, ReactNode> = {
  'layout-grid': (
    <>
      <rect width='7' height='7' x='3' y='3' rx='2.5' />
      <rect width='7' height='7' x='14' y='3' rx='2.5' />
      <rect width='7' height='7' x='14' y='14' rx='2.5' />
      <rect width='7' height='7' x='3' y='14' rx='2.5' />
    </>
  ),
  'layers-2': (
    <>
      <path d='M12 4.5 2 9.5l10 5 10-5z' />
      <path d='m2 14.5 10 5 10-5' />
    </>
  ),
  monitor: (
    <>
      <rect width='20' height='14' x='2' y='3' rx='2' />
      <line x1='8' x2='16' y1='21' y2='21' />
      <line x1='12' x2='12' y1='17' y2='21' />
    </>
  ),
  truck: (
    <>
      <path d='M14.5 16.5v-10A1.5 1.5 0 0 0 13 5H3a1.5 1.5 0 0 0-1.5 1.5V15A1.5 1.5 0 0 0 3 16.5h1.2' />
      <path d='M8.8 16.5h6.4' />
      <path d='M14.5 8.5h4.1a1 1 0 0 1 .76.35l2.9 3.4a1 1 0 0 1 .24.65v2.6a1 1 0 0 1-1 1h-1.7' />
      <circle cx='6.5' cy='16.5' r='2.3' />
      <circle cx='17.5' cy='16.5' r='2.3' />
    </>
  ),
  package: (
    <>
      <path d='M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z' />
      <path d='M12 22V12' />
      <path d='m3.3 7 7.703 4.734a2 2 0 0 0 1.994 0L20.7 7' />
      <path d='m7.5 4.27 9 5.15' />
    </>
  ),
  car: (
    <>
      <path d='M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2' />
      <circle cx='7' cy='17' r='2' />
      <path d='M9 17h6' />
      <circle cx='17' cy='17' r='2' />
    </>
  ),
  map: (
    <>
      <path d='M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z' />
      <path d='M15 5.764v15' />
      <path d='M9 3.236v15' />
    </>
  ),
  search: (
    <>
      <path d='m21 21-4.34-4.34' />
      <circle cx='11' cy='11' r='8' />
    </>
  ),
  'shopping-cart': (
    <>
      <path d='M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12' />
      <circle cx='8' cy='20.5' r='1.25' />
      <circle cx='19' cy='20.5' r='1.25' />
    </>
  ),
  'shield-check': (
    <>
      <path d='M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z' />
      <path d='m9 12 2 2 4-4' />
    </>
  ),
  lock: (
    <>
      <rect width='18' height='11' x='3' y='11' rx='3' />
      <path d='M7 11V7a5 5 0 0 1 10 0v4' />
    </>
  ),
  grid: (
    <>
      <rect width='20' height='17' x='2' y='3.5' rx='2.5' />
      <path d='M2 9.17h20' />
      <path d='M2 14.83h20' />
      <path d='M8.67 3.5v17' />
      <path d='M15.33 3.5v17' />
    </>
  ),
  swap: (
    <>
      <path d='M3 9.5h18l-4.5-4.5' />
      <path d='M21 14.5H3l4.5 4.5' />
    </>
  ),
  clock: (
    <>
      <circle cx='12' cy='12' r='9.5' />
      <path d='M12 7v5l3 2' />
    </>
  ),
  'file-text': (
    <>
      <path d='M6.5 2.5h8l5 5v11.5a2.5 2.5 0 0 1-2.5 2.5H7A2.5 2.5 0 0 1 4.5 19V4.5a2 2 0 0 1 2-2z' />
      <path d='M8.5 13h7' />
      <path d='M8.5 17h7' />
    </>
  ),
  'shopping-basket': (
    <>
      <path d='M2.5 9.5h19l-1.7 9.3a2 2 0 0 1-2 1.7H6.2a2 2 0 0 1-2-1.7z' />
      <path d='M7.5 9.5 12 3l4.5 6.5' />
    </>
  ),
  navigation: (
    <>
      <path d='m3 11 19-9-9 19-2-8z' />
    </>
  ),
  'log-out': (
    <>
      <path d='M14 3.5H5a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h9' />
      <path d='M10 12h11.5' />
      <path d='m17.5 8 4 4-4 4' />
    </>
  ),
  hand: (
    <>
      <path d='M9.5 13.5V6a1.5 1.5 0 0 1 3 0' />
      <path d='M12.5 11V4a1.5 1.5 0 0 1 3 0a1.5 1.5 0 0 1 3 0v7' />
      <path d='M15.5 4v7' />
      <path d='M18.5 6a1.5 1.5 0 0 1 3 0v7.5a8 8 0 0 1-8 8h-1c-3.5 0-6.5-2.5-9-6' />
    </>
  ),
  wallet: (
    <>
      <path d='M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1' />
      <path d='M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4' />
    </>
  ),
  'chart-column': (
    <>
      <path d='M3 3v16a2 2 0 0 0 2 2h16' />
      <path d='M18 17V9' />
      <path d='M13 17V5' />
      <path d='M8 17v-3' />
    </>
  ),
  award: (
    <>
      <path d='m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526' />
      <circle cx='12' cy='8' r='6' />
    </>
  ),
  users: (
    <>
      <path d='M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2' />
      <path d='M16 3.128a4 4 0 0 1 0 7.744' />
      <path d='M22 21v-2a4 4 0 0 0-3-3.87' />
      <circle cx='9' cy='7' r='4' />
    </>
  ),
  smartphone: (
    <>
      <rect width='14' height='20' x='5' y='2' rx='2' ry='2' />
      <path d='M12 18h.01' />
    </>
  ),
  settings: (
    <>
      <path d='M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915' />
      <circle cx='12' cy='12' r='3' />
    </>
  ),
  timer: (
    <>
      <line x1='10' x2='14' y1='2' y2='2' />
      <line x1='12' x2='15' y1='14' y2='11' />
      <circle cx='12' cy='14' r='8' />
    </>
  ),
}

type Props = {
  name: string
  size?: number
}

const AsideMenuIcon: FC<Props> = ({name, size = 20}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth={2}
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
  >
    {ICONS[name]}
  </svg>
)

export {AsideMenuIcon}
